import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "@egovernments/digit-ui-react-components";
import MapSubmissionSummary from "./MapSubmissionSummary";

function SearchSummary({
  id,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration,
  formType,
  isAlreadySubmitted,
  setIsAlreadySubmitted,
  obpasFileNumber,
  setObpasFileNumber,
  dateOfPayment,
  setDateOfPayment,
  paymentReceipt,
  setPaymentReceipt,
}) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const queryFormType = "MAP_SUB";
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(
    stateId,
    { applicationNo: id, isEmployee },
    { formType: queryFormType, config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true } }
  );
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });

  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  useEffect(() => {
    if (id && queryFormType) {
      refetch();
    }
  }, [id, queryFormType, refetch]);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      {!isLoading && data && (
        <MapSubmissionSummary
          formData={data?.BPA?.[0]}
          ref={ref}
          handleDeclarationChange={handleDeclarationChange}
          declarationChecked={declarationChecked}
          showDeclaration={showDeclaration}
          formType={formType}
          logoData={data?.BPA?.[0]?.department == "DA" ? daLogo : avpLogo}
          isAlreadySubmitted={isAlreadySubmitted}
          setIsAlreadySubmitted={setIsAlreadySubmitted}
          obpasFileNumber={obpasFileNumber}
          setObpasFileNumber={setObpasFileNumber}
          dateOfPayment={dateOfPayment}
          setDateOfPayment={setDateOfPayment}
          paymentReceipt={paymentReceipt}
          setPaymentReceipt={setPaymentReceipt}
        />
      )}
    </React.Fragment>
  );
}

export default SearchSummary;
